import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1A2332] text-white">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12">
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/1cfafa4ca96a7381372e5a250ab4f519/ef849cd61baf8ab04ce16204865c1ffd.png"
              alt="Company Logo"
              className="h-12 w-auto mb-8 brightness-0 invert"
            />
            <p className="text-[#B0B8C4] text-base leading-relaxed max-w-sm mb-12">
              Empowering businesses through innovative solutions and expert services tailored to your unique needs.
            </p>
            <div>
              <h4 className="text-sm uppercase tracking-wider mb-4">Stay Updated</h4>
              <div className="flex flex-col gap-4">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="bg-transparent border-b border-white/30 text-white placeholder-white/50 py-3 focus:outline-none focus:border-[#14B8A6] transition-colors"
                />
                <button className="border-2 border-white text-white px-8 py-2.5 rounded-full hover:bg-white hover:text-[#1A2332] transition-all duration-300 whitespace-nowrap cursor-pointer w-40">
                  Subscribe
                </button>
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-wider font-bold mb-5">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-[#B0B8C4] hover:text-[#14B8A6] transition-colors cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-[#B0B8C4] hover:text-[#14B8A6] transition-colors cursor-pointer">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/engagement" className="text-[#B0B8C4] hover:text-[#14B8A6] transition-colors cursor-pointer">
                  Engagement Model
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#B0B8C4] hover:text-[#14B8A6] transition-colors cursor-pointer">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-wider font-bold mb-5">Services</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-[#B0B8C4] hover:text-[#14B8A6] transition-colors cursor-pointer">
                  Consulting
                </a>
              </li>
              <li>
                <a href="#" className="text-[#B0B8C4] hover:text-[#14B8A6] transition-colors cursor-pointer">
                  Development
                </a>
              </li>
              <li>
                <a href="#" className="text-[#B0B8C4] hover:text-[#14B8A6] transition-colors cursor-pointer">
                  Strategy
                </a>
              </li>
              <li>
                <a href="#" className="text-[#B0B8C4] hover:text-[#14B8A6] transition-colors cursor-pointer">
                  Support
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm uppercase tracking-wider font-bold mb-5">Connect</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-[#B0B8C4] hover:text-[#14B8A6] transition-colors cursor-pointer">
                  LinkedIn
                </a>
              </li>
              <li>
                <a href="#" className="text-[#B0B8C4] hover:text-[#14B8A6] transition-colors cursor-pointer">
                  Twitter
                </a>
              </li>
              <li>
                <a href="#" className="text-[#B0B8C4] hover:text-[#14B8A6] transition-colors cursor-pointer">
                  Facebook
                </a>
              </li>
              <li>
                <a href="#" className="text-[#B0B8C4] hover:text-[#14B8A6] transition-colors cursor-pointer">
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#B0B8C4] text-sm">
            © 2025 All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-[#B0B8C4] hover:text-white transition-colors cursor-pointer">
              <i className="ri-linkedin-fill text-xl"></i>
            </a>
            <a href="#" className="text-[#B0B8C4] hover:text-white transition-colors cursor-pointer">
              <i className="ri-twitter-x-fill text-xl"></i>
            </a>
            <a href="#" className="text-[#B0B8C4] hover:text-white transition-colors cursor-pointer">
              <i className="ri-facebook-fill text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}